import { defineStore } from 'pinia';
import { ref } from 'vue';

import type {
  GroupResultDTO,
  GroupResultWithMembersDTO,
} from '@nora-monorepo/nora-api-client';
import { useApiStore } from '@nora-monorepo/ui-shared';

export const useGroupStore = defineStore('groupStore', () => {
  const groups = ref<GroupResultWithMembersDTO[]>([]);
  const groupStack = ref<GroupResultDTO[]>([]);
  const groupsAreLoaded = ref<boolean>(false);

  const api = useApiStore();

  async function bootstrap(): Promise<void> {
    const result = await api.unwrap(api.nexusGroup.getMyGroups());

    if (!result.data) {
      throw new Error('no groups returned');
    }

    groups.value = result.data;
    groupsAreLoaded.value = true;
  }

  const addGroup = (newGroup: GroupResultWithMembersDTO): void => {
    groups.value.push(newGroup);
  };

  const fetchGroup = async (groupId: string): Promise<GroupResultWithMembersDTO> => {
    const result = await api.unwrap(
      api.nexusGroup.getGroup({
        groupId,
      }),
    );

    if (!result.data) {
      throw new Error('no group returned');
    }

    return result.data;
  };

  return {
    groups,
    groupStack,
    groupsAreLoaded,

    bootstrap,
    addGroup,
    fetchGroup,
  };
});
